export default {
  summary: {
    delivery: 'Delivery: Gift card as a PDF via email',
  },
};
